import { reader } from './utils.js';
export function decodeMessage(buf, codec) {
    const r = reader(buf instanceof Uint8Array ? buf : buf.subarray());
    return codec.decode(r);
}
